"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubspotConfigOutSerializer = void 0;
exports.HubspotConfigOutSerializer = {
    _fromJsonObject(object) {
        return {};
    },
    _toJsonObject(self) {
        return {};
    },
};
//# sourceMappingURL=hubspotConfigOut.js.map